import React, { useContext } from 'react';
import { TKUIWithStyle, useStyles } from 'tripkit-react/dist/jss/StyleHelper';
import confirmSignInFormJss from './ConfirmSignInForm.css';
import { TKUIButton, TKUIButtonType } from 'tripkit-react';
import { LoginResult, TKAccountContext } from 'tripkit-react/dist/account/TKAccountContext';
import { ReactComponent as IconLoading } from "tripkit-react/dist/images/ic-spin-bar.svg";
import TKUICheckbox from "tripkit-react/dist/util_components/TKUICheckbox"

type IStyle = ReturnType<typeof confirmSignInFormJss>

interface IProps extends TKUIWithStyle<IStyle, IProps> {
    codeChallenge: Exclude<LoginResult, void>;
    appName?: string;
    onVerified?: () => void;
    onCancel?: () => void;
}

const ConfirmSignInForm: React.FunctionComponent<IProps> = (props: IProps) => {
    const { codeChallenge, appName, onVerified, onCancel, classes, theme } = useStyles(props, confirmSignInFormJss);
    const { confirmLogin, logout } = useContext(TKAccountContext);
    const [verificationCode, setVerificationCode] = React.useState('');
    const [rememberDevice, setRememberDevice] = React.useState(true);
    const [waiting, setWaiting] = React.useState(false);
    const [errorMsg, setErrorMsg] = React.useState<string>('');

    function handleCancel() {
        logout();
        onCancel?.();
    }

    const isEmail = codeChallenge.signInStep === 'CONFIRM_SIGN_IN_WITH_EMAIL_CODE';
    const isSMS = codeChallenge.signInStep === 'CONFIRM_SIGN_IN_WITH_SMS_CODE';
    const deliveryMethod = isEmail ? 'email address' : isSMS ? 'phone number' : 'destination';

    return (
        <>
            <div className={classes.description}>
                {appName ? `${appName} has sent a code to the ${deliveryMethod}: ${codeChallenge.destination}` : `A code has been sent to the ${deliveryMethod}: ${codeChallenge.destination}`}
            </div>
            <div className={classes.description}>
                Enter the code to access your account.
            </div>
            <input
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength={6}
                placeholder="000000"
                value={verificationCode}
                onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, '');
                    setVerificationCode(value);
                }}
                className={classes.codeInput}
                autoFocus
            />
            <div className={classes.errorMessage}>
                {errorMsg}
            </div>
            <div className={classes.rememberDevice}>
                <span>Remember this device</span>
                <TKUICheckbox
                    checked={rememberDevice}
                    onChange={(e) => setRememberDevice(e.target.checked)}
                    theme={theme}
                />
            </div>
            <TKUIButton
                text={waiting ? <IconLoading className={classes.iconLoading} /> : "Verify"}
                type={TKUIButtonType.PRIMARY}
                disabled={verificationCode.length !== 6}
                onClick={async () => {
                    try {
                        setWaiting(true);
                        await confirmLogin({ code: verificationCode, remember: rememberDevice });
                        onVerified?.();
                        setWaiting(false);
                    } catch (error) {
                        console.error('Verification failed:', error);
                        setErrorMsg(error instanceof Error ? error.message : String(error));
                        setWaiting(false);
                    }
                }}
            />
            <TKUIButton
                text="Cancel"
                type={TKUIButtonType.SECONDARY}
                onClick={handleCancel}
            />
        </>
    );
};


export default ConfirmSignInForm;
